import { createTheme } from '@mui/material'

const veraTheme = createTheme({
  palette: {
    background: {
      default: '#f9fafc',
      input: '#f4f6f9',
      paper: '#ffffff',
    },
    primary: {
      light: '#f73378',
      main: '#f50057',
      dark: '#ab003c',
    },
  },
})

export default veraTheme
